import gql from 'graphql-tag';
import { ECHELON_INFO_FRAGMENT } from '../echelon/fragment';
import { PERMISSION_FRAGMENT } from '../role/fragment';

export const USER_INFO_FRAGMENT = gql`
  fragment UserInfo on User {
    id
    createdAt
    avatarUrl
    firstName
    lastName
    civility
    email
    phone
    roles
    blocked
    directoryToken
    iban
    bic
    agency
    agencyName
    agencyAddress
    isManager
    enseigneName
    isDeleted
    enseigne {
      id
      name
    }
    entities {
      id
      name
    }
    mandatary {
      id
      firstName
      lastName
    }
    crossEnseignes {
      id
      name
    }
    teams {
      id
      name
    }
    idCRM
    permissions {
      ...PermissionInfo
    }
    isMobile
  }
  ${PERMISSION_FRAGMENT}
`;

export const ADDITIONAL_USER_INFO_FRAGMENT = gql`
  fragment AdditionalUserInfo on User {
    agencyAddress
    agency
    iban
    bic
    createdAt
    mandatary {
      id
      firstName
      lastName
    }
  }
`;

export const USER_ENSEIGNE_ENTITIES_INFO_FRAGMENT = gql`
  fragment UserEnseigneEntitiesInfo on User {
    id
    firstName
    lastName
    enseigne {
      id
      name
    }
    entities {
      id
      name
    }
  }
`;

export const GET_USER_POSSIBLE_ENTITIES_INFO_FRAGMENT = gql`
  fragment UserPossibleEntitiesInfo on User {
    id
    avatarUrl
    firstName
    lastName
    roles
    enseigne {
      id
      entities {
        id
        name
        echelon {
          ...EchelonInfo
        }
        managers {
          id
        }
      }
    }
  }
  ${ECHELON_INFO_FRAGMENT}
`;
// ----------------------------- NEW USER INFOS [SPRINT 4] ------------------------------------

export const USER_HEADER_INFO_FRAGMENT = gql`
  fragment UserHeaderInfo on User {
    id
    avatarUrl
    firstName
    lastName
    enseigneName
    roles
    createdAt
    idCRM
    civility
  }
`;

export const USER_COORDONNEES_INFO_FRAGMENT = gql`
  fragment UserCoordonneesInfo on User {
    email
    phone
  }
`;

export const USER_RATTACHEMENT_INFO_FRAGMENT = gql`
  fragment UserRattachementInfo on User {
    enseigne {
      id
      name
      entities {
        id
        name
        echelon {
          ...EchelonInfo
        }
        managers {
          id
        }
      }
    }
    entities {
      id
      name
    }
  }
  ${ECHELON_INFO_FRAGMENT}
`;

export const USER_REGIME_IDENTIFIANTS_INFO_FRAGMENT = gql`
  fragment UserRegimeIdentifiantsInfo on User {
    apaStatus
    siren
    rib
    secu
    iban
  }
`;
